import React from 'react';
import config from '../../config';

export default function ContactUs() {
  return (
    <section className="page-section" id="contact">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8 text-center">
            <h2 className="mt-0">Kontakt</h2>
            <hr className="divider my-4" />
            <p className="text-muted mb-5">
              Fragen? Offerte? Rufen Sie an oder schreiben Sie mir – ich melde 
              mich schnellstmöglich zurück.
            </p>
          </div>
        </div>

        <div className="row text-center mb-5">
          <div className="col-lg-3 mb-4 mb-lg-0">
            <div className="contact-card">
              <i className="fas fa-map-marker-alt fa-2x text-primary mb-3"></i>
              <h3 className="h6 text-uppercase font-weight-bold mb-2">Adresse</h3>
              <a
                href="https://www.google.com/maps/search/Wasescha+Maler+Gravas+6+7452+Cunter+Switzerland"
                target="_blank"
                rel="noopener noreferrer"
                className="text-muted"
              >
                <span style={{ fontWeight: 600 }}>Wasescha Maler</span>
                <br />
                Ricardo Wasescha
                <br />
                Gravas 6
                <br />
                7452 Cunter
              </a>
            </div>
          </div>
          <div className="col-lg-3 mb-4 mb-lg-0">
            <div className="contact-card">
              <i className="fas fa-phone fa-2x text-primary mb-3"></i>
              <h3 className="h6 text-uppercase font-weight-bold mb-2">Telefon</h3>
              <a className="d-block text-muted" href="tel:+41815589899">
                +41 (0) 81 558 98 99
              </a>
            </div>
          </div>
          <div className="col-lg-3 mb-4 mb-lg-0">
            <div className="contact-card">
              <i className="fas fa-mobile-alt fa-2x text-primary mb-3"></i>
              <h3 className="h6 text-uppercase font-weight-bold mb-2">Mobile</h3>
              <a className="d-block text-muted" href="tel:+41792637706">
                +41 (0) 79 263 77 06
              </a>
            </div>
          </div>
          <div className="col-lg-3 mb-4 mb-lg-0">
            <div className="contact-card">
              <i className="fas fa-envelope fa-2x text-primary mb-3"></i>
              <h3 className="h6 text-uppercase font-weight-bold mb-2">E-Mail</h3>
              <a className="d-block text-muted" href={`mailto:${config.email}`}>
                {config.email}
              </a>
            </div>
          </div>
        </div>

        <div
          className="row justify-content-center"
          style={{ marginBottom: 80 }}
        >
          <div className="col-lg-8 text-center mt-3">
            <a
              href="https://www.google.com/maps/search/Wasescha+Maler+Gravas+6+7452+Cunter+Switzerland"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-outline-primary btn-lg"
            >
              <i className="fas fa-directions mr-2"></i>
              Route planen
            </a>
          </div>
          {config.socialLinks.length > 0 && (
            <div className="col-lg-8 text-center mt-4 mb-lg-0">
              {config.socialLinks.map(social => {
                const { icon, url } = social;
                return (
                  <a key={url} href={url} className={`mx-2`}>
                    <i className={`fab fa-3x mb-3 ${icon}`}></i>
                  </a>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}